module.exports = __webpack_public_path__ + "img/image-3.d0efd0ed.jpg";